<template>
  <div class="loading-skeleton">
    <SkeletonLoader show-animation>
      <div class="loading-skeleton__input" />
      <div class="loading-skeleton__search-filter" />
      <div class="loading-skeleton__title" />
    </SkeletonLoader>
    <Grid :columns="[3, 3, 3]" class="loading-skeleton__cards" :gutter="32">
      <SkeletonLoader v-for="index in 3" :key="index" show-animation>
        <div class="loading-skeleton__card" />
      </SkeletonLoader>
    </Grid>
    <SkeletonLoader show-animation>
      <div class="loading-skeleton__section-title" />
    </SkeletonLoader>
    <Grid :columns="[5, 5]" :gutter="32">
      <SkeletonLoader v-for="index in 6" :key="index" show-animation>
        <div class="loading-skeleton__item" />
      </SkeletonLoader>
    </Grid>
  </div>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

import { SkeletonLoader, Grid } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    SkeletonLoader,
    Grid
  }
})
export default class Loading extends Vue {}
</script>
<style lang="less" scoped>
.loading-skeleton {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 @size-spacing-x400;

  &__input {
    height: @size-spacing-x1000;
    max-width: 800px;
    margin: 0 auto;
    border-radius: 4px;
  }

  &__search-filter {
    height: @size-spacing-x800;
    width: 100%;
    margin: @size-spacing-x800 0;
    border-radius: 12px;
  }

  &__title {
    height: @size-spacing-x600;
    width: 45%;
    border-radius: 12px;
  }

  &__cards {
    margin: @size-spacing-x400 0 @size-spacing-x800 0;
  }

  &__card {
    height: 279px;
    border-radius: 16px;
    margin-bottom: @size-spacing-x400;
  }

  &__section-title {
    height: @size-spacing-x600;
    border-radius: 12px;
    width: 45%;
    margin-bottom: @size-spacing-x400;
  }

  &__item {
    height: @size-spacing-x500;
    widows: 100%;
    margin: @size-spacing-x350 0;
    border-radius: 8px;
  }
}

@media @notebookUp {
  .loading-skeleton {
    padding: 0 @size-spacing-x800;
    &__search-filter {
      width: 30%;
    }
    &__title {
      width: 20%;
    }
    &__card {
      margin-bottom: 0;
    }
    &__section-title {
      width: 15%;
    }
  }
}
</style>
